// src/components/MetaTags.js
import { Helmet } from "react-helmet";
import { useContext } from "react";
import { LanguageContext } from "../../context/LanguageContext"; 

const MetaTags = () => {
  const { language } = useContext(LanguageContext);
  const lang = language || "en";

  const meta = {
    DE: {
      description:
        "TeamCoin verbindet Sportvereine und Einzelsportler direkt mit Sponsoren. Unterstütze deinen Lieblingsverein oder Sportler mit wenigen Klicks – transparent, digital und ohne Umwege. Jetzt mitmachen und Teil der neuen Sportförderung werden – für Fußball, Tennis, Radsport, Golf und viele weitere Sportarten.",
      ogTitle: "TeamCoin – Sportförderung für Vereine & Sportler direkt",
      ogDescription:
        "Mit TeamCoin kannst du direkt deinen Verein oder Sportler unterstützen. Einfach online, fair und nachvollziehbar. Jetzt mitmachen – Fußball, Tennis, Radsport, Golf & mehr!",
      twitterTitle: "TeamCoin – Sportförderung für Vereine & Sportler",
      twitterDescription:
        "Direkt spenden – direkt helfen. Unterstütze Sportvereine und Sportler auf TeamCoin.",
    },
    EN: {
      description:
        "TeamCoin connects sports clubs and individual athletes directly with sponsors. Support your favorite team or athlete with just a few clicks – transparent, digital, and straightforward. Join now and be part of the new era in sports funding – for football, tennis, cycling, golf, and many more sports.",
      ogTitle: "TeamCoin – Direct Sports Sponsorship for Clubs & Athletes",
      ogDescription:
        "With TeamCoin you can support your club or athlete directly. Simple, fair, and traceable. Join now – football, tennis, cycling, golf & more!",
      twitterTitle: "TeamCoin – Direct Sponsorship for Clubs & Athletes",
      twitterDescription:
        "Donate directly – help immediately. Support sports clubs and athletes on TeamCoin.",
    },
  };

  const content = meta[lang] || meta.DE;
  console.log("Language in Helmet:", language,meta);


  return (

    <Helmet>
      <meta name="test-meta-tag" content="Helmet works!" />



      {/* Open Graph */}
      <meta property="og:title" content={content.ogTitle} />
      <meta property="og:description" content={content.ogDescription} />
      <meta property="og:image" content="https://www.teamcoin.de/assets/og-image.jpg" />
      <meta property="og:url" content="https://www.teamcoin.de" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="TeamCoin" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={content.twitterTitle} />
      <meta name="twitter:description" content={content.twitterDescription} />
      <meta name="twitter:image" content="https://www.teamcoin.de/assets/og-image.jpg" />
    </Helmet>
  );
};

export default MetaTags;